module.exports = __webpack_public_path__ + "static/media/cq_freccia_giu.5993d05d.svg";